'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxSimple = require('redux-simple');

var _reactOnclickout = require('react-onclickout');

var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _userActions = require('../../actions/userActions');

var _routing = require('../../actions/routing');

var _projectsActions = require('../../actions/projectsActions');

var _routing2 = require('../../constants/routing');

var _Common = require('../../components/Common');

var _User = require('../../components/User');

var _Icons = require('../../components/Common/Icons');

var _ProjectMenu = require('./ProjectMenu');

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Auth = require('../../components/Auth');

var _ProjectView = require('./ProjectView/ProjectView');

var _ProjectView2 = _interopRequireDefault(_ProjectView);

var _Projects = require('../../components/Projects');

var _projectPermissions = require('../../components/Projects/projectPermissions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./ProjectPage.pcss');

// import COLORS_SET from '../../constants/colors';
// import { randomElement } from '../../utils/utils';

var DEFAULT_ADDED_NODE_COLOR = '#d0d0d0';

var getState = function getState(state) {
  return {
    projectId: state.routing.params.projectId,
    nodeId: state.routing.params.nodeId,
    routeType: state.routing.type,

    foreignUser: state.routing.foreignUser,
    authorizedUser: state.user.authorizedUser,
    shownUser: state.user.shownUser,

    firstLogin: state.user.firstLogin,
    welcomePopupShown: state.user.welcomePopupShown,
    project: state.projects.project
  };
};

var getActions = {
  showWelcomePopup: _userActions.showWelcomePopup,
  addNode: _projectsActions.addNode,
  updateNode: _projectsActions.updateNode,
  updateNodes: _projectsActions.updateNodes,
  addEdge: _projectsActions.addEdge,
  removeEdge: _projectsActions.removeEdge,
  confirmRemoveNode: _projectsActions.confirmRemoveNode,
  detachNode: _projectsActions.detachNode,
  appendNewNode: _projectsActions.appendNewNode,
  appendRightNode: _projectsActions.appendRightNode,
  appendRightConnectedNode: _projectsActions.appendRightConnectedNode,
  appendBottomConnectedNode: _projectsActions.appendBottomConnectedNode,
  goLeft: _routing.goLeft,
  projectDelete: _projectsActions.projectDelete,
  openIndex: _routing.openIndex,

  previewNode: function previewNode(projectId, nodeId) {
    return {
      type: _routing2.JALAN_PROJECT_NODE,
      params: { projectId: projectId, nodeId: nodeId }
    };
  }
};

var ProjectPage = (_dec = (0, _reduxSimple.connect)(getState, getActions), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(ProjectPage, _Component);

  function ProjectPage(props) {
    _classCallCheck(this, ProjectPage);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectPage).call(this, props));

    _this.state = {
      showingMenu: false,
      viewport: { x: 0, y: 0 },
      draggingViewport: false,

      projectNameEditing: false,
      editProjectViewNodesOnMount: false
    };
    return _this;
  }

  _createClass(ProjectPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ showing: true });
    }
  }, {
    key: 'handleProjectViewClick',
    value: function handleProjectViewClick(e) {
      var draggingViewport = this.state.draggingViewport;


      if (draggingViewport) {
        e.stopPropagation();
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var currId = this.props.projectId;
      var nextId = nextProps.projectId;


      if (currId !== nextId) {
        this.setState({ editProjectViewNodesOnMount: false });
      }
    }
  }, {
    key: 'showMenu',
    value: function showMenu() {
      if (this.state.showingMenu) return;
      this.setState({ showingMenu: true });
    }
  }, {
    key: 'hideMenu',
    value: function hideMenu() {
      if (!this.state.showingMenu) return;
      this.setState({ showingMenu: false });
    }
  }, {
    key: 'isViewingProject',
    value: function isViewingProject() {
      var routeType = this.props.routeType;

      return routeType === _routing2.JALAN_PROJECT;
    }
  }, {
    key: 'isPreviewingNode',
    value: function isPreviewingNode() {
      var routeType = this.props.routeType;

      return routeType === _routing2.JALAN_PROJECT_NODE;
    }
  }, {
    key: 'isPreviewingProject',
    value: function isPreviewingProject() {
      var routeType = this.props.routeType;

      return routeType === _routing2.JALAN_INDEX_PROJECT;
    }
  }, {
    key: 'isViewingUser',
    value: function isViewingUser() {
      var routeType = this.props.routeType;

      return routeType === _routing2.JALAN_INDEX || routeType === _routing2.JALAN_USER_LIST;
    }
  }, {
    key: 'isViewingNode',
    value: function isViewingNode() {
      var routeType = this.props.routeType;

      return routeType === _routing2.JALAN_NODE;
    }
  }, {
    key: 'getPreviewingNodeId',
    value: function getPreviewingNodeId() {
      var nodeId = this.props.nodeId;

      return nodeId;
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      this.props.goLeft();
    }
  }, {
    key: 'addNode',
    value: function addNode() {
      var _state$viewport = this.state.viewport;
      var x = _state$viewport.x;
      var y = _state$viewport.y;

      var color = DEFAULT_ADDED_NODE_COLOR;
      var caption = 'new node';

      this.setState({ editProjectViewNodesOnMount: true });
      this.props.addNode({ x: x, y: y, color: color, caption: caption });
    }
  }, {
    key: 'appendNewNode',
    value: function appendNewNode(id) {
      var _state$viewport2 = this.state.viewport;
      var x = _state$viewport2.x;
      var y = _state$viewport2.y;

      var color = DEFAULT_ADDED_NODE_COLOR;
      var caption = 'child node';

      this.setState({ editProjectViewNodesOnMount: true });
      this.props.appendNewNode({ id: id, x: x, y: y, color: color, caption: caption });
    }
  }, {
    key: 'appendRightConnectedNode',
    value: function appendRightConnectedNode(id, _ref) {
      var x = _ref.x;
      var y = _ref.y;

      var color = DEFAULT_ADDED_NODE_COLOR;
      var caption = 'child node';

      this.setState({ editProjectViewNodesOnMount: true });
      this.props.appendRightConnectedNode({ id: id, x: x, y: y, color: color, caption: caption });
    }
  }, {
    key: 'appendRightNode',
    value: function appendRightNode(id, _ref2) {
      var x = _ref2.x;
      var y = _ref2.y;

      var color = DEFAULT_ADDED_NODE_COLOR;
      var caption = 'child node';

      this.setState({ editProjectViewNodesOnMount: true });
      this.props.appendRightNode({ id: id, x: x, y: y, color: color, caption: caption });
    }
  }, {
    key: 'appendBottomConnectedNode',
    value: function appendBottomConnectedNode(id, _ref3) {
      var x = _ref3.x;
      var y = _ref3.y;

      var color = DEFAULT_ADDED_NODE_COLOR;
      var caption = 'child node';

      this.setState({ editProjectViewNodesOnMount: true });
      this.props.appendBottomConnectedNode({ id: id, x: x, y: y, color: color, caption: caption });
    }
  }, {
    key: 'updateViewportPosition',
    value: function updateViewportPosition(_ref4) {
      var x = _ref4.x;
      var y = _ref4.y;

      this.setState({ viewport: { x: x, y: y } });
    }
  }, {
    key: 'handleViewportDragStart',
    value: function handleViewportDragStart() {
      this.setState({ draggingViewport: true });
    }
  }, {
    key: 'handleViewportDragStop',
    value: function handleViewportDragStop() {
      var _this2 = this;

      (0, _raf2.default)(function () {
        _this2.setState({ draggingViewport: false });
      });
    }
  }, {
    key: 'previewNode',
    value: function previewNode(nodeId) {
      var _props = this.props;
      var projectId = _props.projectId;
      var previewNode = _props.previewNode;

      previewNode(projectId, nodeId);
    }
  }, {
    key: 'getMenuContainer',
    value: function getMenuContainer() {
      return _react2.default.createElement(
        _reactOnclickout2.default,
        { onClickOut: this.hideMenu.bind(this) },
        _react2.default.createElement(
          'div',
          { className: styles.menuContainer },
          _react2.default.createElement(
            _Common.ActionIcon,
            { onClick: this.showMenu.bind(this), smallShadow: true, right: true },
            _react2.default.createElement(_Icons.Hamburger, { width: '16', height: '12' })
          ),
          this.state.showingMenu && _react2.default.createElement(
            'div',
            { className: styles.menu },
            _react2.default.createElement(_ProjectMenu2.default, { onClose: this.hideMenu.bind(this), rename: this.editProjectName.bind(this) })
          )
        )
      );
    }
  }, {
    key: 'editProjectName',
    value: function editProjectName() {
      this.setState({ projectNameEditing: true });
    }
  }, {
    key: 'finishEditProjectName',
    value: function finishEditProjectName() {
      this.setState({ projectNameEditing: false });
    }
  }, {
    key: 'handleProjectDelete',
    value: function handleProjectDelete() {
      this.props.projectDelete(this.props.project);
      this.props.openIndex();
    }
  }, {
    key: 'isProjectEmpty',
    value: function isProjectEmpty() {
      var nodesData = this.props.project.nodesData;

      if ((0, _shallowequal2.default)(nodesData, {})) return true;
      if (!nodesData) return true;
      return false;
    }
  }, {
    key: 'isProjectForeign',
    value: function isProjectForeign() {
      var _props2 = this.props;
      var project = _props2.project;
      var authorizedUser = _props2.authorizedUser;


      if (!authorizedUser) return true;
      if (!project) return false;

      return project.owner !== authorizedUser.id;
    }
  }, {
    key: 'getEmptyForeignProjectView',
    value: function getEmptyForeignProjectView() {
      var shownUser = this.props.shownUser;


      var userName = shownUser.displayName;

      return _react2.default.createElement(
        'div',
        { className: styles.emptyView },
        _react2.default.createElement(
          'div',
          { className: styles.container },
          _react2.default.createElement(
            'div',
            { className: styles.caption },
            userName,
            ' hasn\'t added anything to this project yet.',
            _react2.default.createElement('br', null),
            'How about making your own project with Meta?',
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(
            'div',
            { className: styles.startNewProject },
            _react2.default.createElement(_Common.StartNewProjectButton, null)
          )
        )
      );
    }
  }, {
    key: 'getProjectViewContent',
    value: function getProjectViewContent() {
      var project = this.props.project;
      var editProjectViewNodesOnMount = this.state.editProjectViewNodesOnMount;


      var canEditProject = this.canEditProject();

      if (!canEditProject && this.isProjectEmpty()) {
        return this.getEmptyForeignProjectView();
      }

      return _react2.default.createElement(_ProjectView2.default, {
        ref: 'projectView',
        data: project,
        previewingProject: this.isPreviewingProject(),
        viewingUser: this.isViewingUser(),
        viewingNode: this.isViewingNode(),
        canPreviewNode: this.isViewingProject() || this.isPreviewingNode(),
        viewingProject: this.isViewingProject(),
        previewingNode: this.isPreviewingNode(),
        previewingNodeId: this.getPreviewingNodeId(),

        onNodeUpdate: this.props.updateNode,
        onNodesUpdate: this.props.updateNodes,
        onNodeRemove: this.props.confirmRemoveNode,
        onNodeDetach: this.props.detachNode,
        onNodeAppendNew: this.appendNewNode.bind(this),
        onNodeAppendRight: this.appendRightNode.bind(this),
        onNodeAppendRightConnected: this.appendRightConnectedNode.bind(this),
        onNodeAppendBottomConnected: this.appendBottomConnectedNode.bind(this),
        onEdgeRemove: this.props.removeEdge,

        onProjectDelete: this.handleProjectDelete.bind(this),

        onNodePreview: this.previewNode.bind(this),
        initSceneX: 0, initSceneY: 0,
        onViewportPositionChange: this.updateViewportPosition.bind(this),
        onEdgeConnectionRequest: this.props.addEdge,

        disableModifications: !canEditProject,
        editNodesOnMount: editProjectViewNodesOnMount,

        onViewportDragStart: this.handleViewportDragStart.bind(this),
        onViewportDragStop: this.handleViewportDragStop.bind(this)
      });
    }
  }, {
    key: 'getProjectView',
    value: function getProjectView() {
      var routeType = this.props.routeType;

      var showLogo = this.isProjectForeign();
      var canEdit = this.canEditProject();
      var showControls = routeType === _routing2.JALAN_PROJECT || routeType === _routing2.JALAN_PROJECT_NODE;

      return _react2.default.createElement(
        'div',
        { onClick: this.handleProjectViewClick.bind(this), className: styles.project },
        this.getProjectViewContent(),
        canEdit && _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.addNode, !showControls && styles.hidden) },
          _react2.default.createElement(
            _Common.ActionIcon,
            { onClick: this.addNode.bind(this) },
            _react2.default.createElement(_Icons.Plus, { width: '16', height: '16' })
          )
        ),
        showLogo && _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '55', height: '40' })
      );
    }

    //TODO move this logic upper (to get this from reducer)

  }, {
    key: 'canEditProject',
    value: function canEditProject() {
      var _props3 = this.props;
      var _props3$project = _props3.project;
      var project = _props3$project === undefined ? {} : _props3$project;
      var _props3$authorizedUse = _props3.authorizedUser;
      var authorizedUser = _props3$authorizedUse === undefined ? {} : _props3$authorizedUse;


      if (!project || !authorizedUser) return false;

      var owner = project.owner;
      var userId = authorizedUser.id;


      if (!owner || !userId) return false;

      return owner === userId;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var project = _props4.project;
      var projectId = _props4.projectId;
      var authorizedUser = _props4.authorizedUser;
      var shownUser = _props4.shownUser;
      var routeType = _props4.routeType; // TODO FIX

      var showControls = routeType === _routing2.JALAN_PROJECT || routeType === _routing2.JALAN_PROJECT_NODE;

      if (!project || project.id && projectId && project.id !== projectId) {
        return showControls ? _react2.default.createElement(_Common.Spinner, { routeSpinner: true }) : _react2.default.createElement(_Common.Spinner, { halfRouteSpinner: true });
      }

      var className = (0, _classnames2.default)(styles.projectWrapper, styles.enter, this.state.showing && styles.enterActive);

      var projectNameClassName = (0, _classnames2.default)(styles.projectName, project.id === project.id ? styles.editableName : styles.nonEditableName, this.state.projectNameEditing && styles.projectNameEditing);

      var user = shownUser || authorizedUser;
      var permission = !!user ? (0, _projectPermissions.getPermission)(project, user.publicProjects) : null;
      var permissionIcon = (0, _projectPermissions.getPermissionIcon)(permission);

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: styles.bars },
          _react2.default.createElement(
            _Common.TopBar,
            { left: true, hidden: !showControls },
            _react2.default.createElement(
              _Common.ActionIcon,
              { onClick: this.goBack.bind(this) },
              _react2.default.createElement(_Icons.ArrowBack, { width: '15', height: '14' })
            ),
            _react2.default.createElement(
              'div',
              { className: projectNameClassName },
              !this.state.projectNameEditing && _react2.default.createElement(
                'span',
                null,
                project.name
              ),
              !this.state.projectNameEditing && permissionIcon && _react2.default.createElement(
                'span',
                { className: styles.permissionIcon },
                permissionIcon
              ),
              this.state.projectNameEditing && _react2.default.createElement(_Projects.ProjectsListItemEdit, { project: project, afterEdit: this.finishEditProjectName.bind(this) })
            )
          ),
          _react2.default.createElement(
            _Common.TopBar,
            { right: true, hidden: !showControls },
            !this.isProjectForeign() && this.getMenuContainer(),
            authorizedUser ? _react2.default.createElement(
              _Common.ActionIcon,
              { smallShadow: true, margined: true },
              _react2.default.createElement(_User.UserMenu, { compact: true })
            ) : _react2.default.createElement(_Auth.LoginSmall, null)
          )
        ),
        this.getProjectView()
      );
    }
  }]);

  return ProjectPage;
}(_react.Component), _class2.propTypes = {
  project: _react.PropTypes.object,
  foreignUser: _react.PropTypes.string,
  projectId: _react.PropTypes.string,
  authorizedUser: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ProjectPage;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectPage.js
// module id = 217
// module chunks = 1